import type { TradeEvent, TradeRejected } from '@shefira/shared';

import { uiFormat } from './text.js';

/** What the chat says when something happens to a trade (ADR 0034). */
export function tradeEventText(event: TradeEvent): string {
  switch (event.kind) {
    case 'requested':
      return uiFormat("Proposition d'échange envoyée à {name}.", { name: event.name });
    case 'declined':
      return uiFormat("{name} décline l'échange.", { name: event.name });
    case 'expired':
      return uiFormat("{name} n'a pas répondu à la proposition d'échange.", { name: event.name });
    case 'cancelled':
      return uiFormat("L'échange avec {name} est annulé.", { name: event.name });
    case 'completed':
      return uiFormat('Échange conclu avec {name}.', { name: event.name });
    case 'too-far':
      return uiFormat("Trop loin de {name} : l'échange est rompu.", { name: event.name });
    case 'left':
      return uiFormat("{name} n'est plus là : l'échange est rompu.", { name: event.name });
  }
}

export const TRADE_REFUSAL_TEXT: Record<TradeRejected['reason'], string> = {
  invalid: 'Demande refusée.',
  'not-found': "Personne de ce nom n'est dans la zone.",
  self: 'Tu ne peux pas échanger avec toi-même.',
  'too-far': 'Approche-toi de ce joueur pour échanger.',
  busy: 'Ce joueur est déjà occupé.',
  dead: "Un mort n'échange rien.",
  pending: 'Une proposition attend déjà sa réponse.',
  'no-request': "Cette proposition n'est plus valable.",
  'not-trading': "Tu n'es pas en train d'échanger.",
  'unknown-item': "Tu n'as plus cet objet dans ton sac.",
  quantity: "Tu n'en as pas autant.",
  bound: 'Cette pièce est liée : elle ne se donne pas.',
  cooldown: 'Un achat de la boutique ne s’échange pas avant quatorze jours.',
  'missing-gold': "Ta bourse n'y suffit pas.",
  'bag-full': 'Un des deux sacs est plein.',
  restarting: 'Le serveur redémarre : échange impossible pour l’instant.',
};
